module.exports = __webpack_public_path__ + "img/icon21.34762056.png";